module.exports = __webpack_public_path__ + "img/20191126185121_1176.ad6d6593.png";